import toast from 'react-hot-toast';
import axiosInstance from 'services/axiosMiddleware';

export async function getFeatureNotification() {
  try {
    const response = await axiosInstance.post('feature-notifications/get-feature-notifications');

    if (response.data.status) {
      return response.data; // Return the array of categories
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message); // Throw an error with the message if status is false
    }
  } catch (error) {
    console.error('Error fetching feature notifications data:', error);
    throw error; // Re-throw the error to be handled by react-query
  }
}
